import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 178,
	height: 178,
	viewBox: "0 0 178 178",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M163.76 10.68C163.76 4.79766 158.962 -2.09712e-07 153.08 -4.66838e-07L60.1863 -4.52735e-06C87.9431 5.21484 119.079 11.0555 120.595 11.3475C129.815 13.1553 135.28 20.1084 135.28 30.0375L135.28 167.32L138.84 167.32C144.722 167.32 149.52 162.522 149.52 156.64L149.52 64.1912C149.882 63.2039 153.108 61.1736 154.86 60.075C159.227 57.3355 163.76 54.5264 163.76 49.84L163.76 10.68ZM128.16 30.0375C128.16 25.4762 126.561 19.8025 119.149 18.3562C116.84 17.8973 43.0399 4.03281 21.5825 -6.21478e-06L21.36 -6.2245e-06C15.4777 -6.48163e-06 10.68 4.79765 10.68 10.68L10.68 149.52C10.68 155.291 15.2969 160.005 21.0263 160.2L116.813 177.889L117.48 178C123.362 178 128.16 173.202 128.16 167.32L128.16 30.0375Z",
		fill: "currentColor"
	})
});
export default SvgIconFolder;
